import React from 'react'
import { IntlProvider } from 'react-intl'
import { LocaleProvider } from 'antd'
import AppLocale from '../../lngProvider'
import config from '../../util/config'

export default function IntlProviderApp({ children }) {
    const currentAppLocale = AppLocale[config.currentAppLocale]

    return (
        <LocaleProvider locale={currentAppLocale.antd}>
            <IntlProvider
                locale={currentAppLocale.locale}
                messages={currentAppLocale.messages}
            >
                {children}
            </IntlProvider>
        </LocaleProvider>
    )
}
